import styled from "@emotion/styled";
import axios from "axios";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";
import assets from "../../assets/assets";
import mkaraokeBG from "../../assets/images/mkaraoke-background.png";
import mskaraokeCover from "../../assets/images/mkaraoke-cover.png";
import mmusicBG from "../../assets/images/mmusic-background.png";
import mmusicCover from "../../assets/images/mmusic-cover.png";
import { useAxiosConfigGlobal } from "../Config/axios";
import { distributionUrl } from "../Config/url";
import { IconController } from "../Scripts/ImgController";
import NotificationPopup from "../UI/Login/NotificationPopup";
import useIsMobile from "../Scripts/useIsMobile";

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  position: relative;
`;

const SplitScreen = ({ oneRingRulesAll }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);
  const isMobile = useIsMobile();
  // Утсан дээр hover байхгүй тул хоёр тал үргэлж нээлттэй харагдана
  const isActive = (side) => isMobile || hovered === side;
  const sideStyle = (side) =>
    isMobile
      ? { width: "100%", height: "50%" }
      : { width: isActive(side) ? "80%" : "50%" };

  const [authenticated, setAuthenticated] = useState(false);
  const [cookie, setCookie, removeCookie] = useCookies();
  const [searchParams] = useSearchParams();
  const accessTokenParameter = searchParams.get("access_token");
  const authParameter = searchParams.get("authorized");
  const axiosConfig = useAxiosConfigGlobal();
  const [BEPopup, setBEPopup] = useState(false);
  const [BEPopupType, setBEPopupType] = useState("");
  const [BEPopupMessage, setBEPopupMessage] = useState("");

  const axiosHeader = {
    headers: {
      Accept: "application/json",
      Authorization:
        "Bearer " + (searchParams.get("access_token") ?? cookie.mmusic_token),
    },
  };

  const addHours = (date, hours) => {
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    return date;
  };

  useEffect(() => {
    if (accessTokenParameter && authParameter) {
      console.log(authParameter);
      localStorage.clear();
      removeCookie("mmusic_token");
      removeCookie("who_am_i");

      axios
        .get(distributionUrl + "panel-api/oauth/current:access", axiosHeader)
        .then((res) => {
          if (res.status === 200) {
            setCookie("mmusic_token", accessTokenParameter, {
              expires:
                authParameter === "publisher"
                  ? addHours(new Date(), 24)
                  : addHours(new Date(), 1),
            });
            setCookie("who_am_i", authParameter, {
              expires:
                authParameter === "publisher"
                  ? addHours(new Date(), 24)
                  : addHours(new Date(), 1),
            });
            localStorage.setItem(
              "Current-Access",
              JSON.stringify(res.data.data),
            );
            setTimeout(() => setAuthenticated(true), 1000);
          }
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            oneRingRulesAll("logout");
          }
        });
    } else {
      if (cookie.mmusic_token) {
        axios
          .get(distributionUrl + "panel-api/oauth/current:access", axiosConfig)
          .then((res) => {
            if (res.status === 200) {
              localStorage.setItem(
                "Current-Access",
                JSON.stringify(res.data.data),
              );
              setTimeout(() => setAuthenticated(true), 1000);
            }
          })
          .catch((err) => {
            if (err.response?.status === 401) {
              oneRingRulesAll("logout");
            }
          });
      } else {
        navigate("/login");
      }
    }
  }, []);

  return (
    <Wrapper>
      <div className="fixed top-5 right-4 md:right-5 z-50">
        <NotificationPopup
          popup={BEPopup}
          setPopup={setBEPopup}
          type={BEPopupType}
          popupMessage={BEPopupMessage}
          animDirectionTop={true}
        />
      </div>
      <div className="h-full flex flex-col md:flex-row overflow-hidden">
        {/* Mmusic Side */}
        <motion.div
          layout
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          onMouseEnter={() => setHovered("music")}
          onMouseLeave={() => setHovered(null)}
          className={`group flex items-center justify-center cursor-pointer px-6 md:px-14 relative overflow-hidden`}
          style={{
            ...sideStyle("music"),
            backgroundImage: `url(${
              isActive("music") ? mmusicCover : mmusicBG
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* 🔮 Gradient Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: isActive("music") ? 1 : 0 }}
            transition={{ duration: 0.4 }}
            className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-black/60 backdrop-blur-sm z-0"
          />

          {/* 🔍 Background Zoom effect */}
          <motion.div
            className="absolute inset-0 z-0"
            animate={{ scale: isActive("music") ? 1.05 : 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            style={{
              backgroundImage: `url(${
                isActive("music") ? mmusicCover : mmusicBG
              })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: isActive("music") ? "blur(1px)" : "none",
            }}
          />

          {/* 💬 Content */}
          <div className="flex flex-col items-start gap-4 md:gap-8 z-10 relative">
            <motion.div
              initial={{ x: "-50%", y: "-50%" }}
              animate={
                isActive("music")
                  ? {
                      x: 0,
                      y: 0,
                      left: "0",
                      top: "0",
                      position: "relative",
                    }
                  : {
                      x: "0",
                      y: "0",
                      left: "6rem",
                      top: "5rem",
                      position: "relative",
                    }
              }
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="z-10"
            >
              <img
                src={assets.image.MmusicLogo}
                alt="MMusic"
                className="h-14 md:h-20 w-auto max-w-full"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{
                opacity: isActive("music") ? 1 : 0,
                x: isActive("music") ? 0 : 50,
              }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              className="flex flex-col items-start gap-4 md:gap-8"
            >
              <p className="text-white font-normal leading-6 text-sm md:text-base">
                Таны бүтээлийг хэр олон хүн дуулж, татаж, хандив өгснийг{" "}
                <br className="hidden md:block" />
                хянаж, орлогоо өдөр бүр өсгөх боломжийг ашиглаарай.
              </p>
              <motion.button
                whileHover={{ scale: 1.04 }}
                className="bg-mmusic px-6 py-3 text-white rounded-full flex items-center gap-2"
                onClick={() => {
                  navigate("/music");
                }}
              >
                <p>Үргэлжлэх</p>
                <IconController
                  src={assets.svg.rightArrow}
                  className="w-6 h-6"
                />
              </motion.button>
            </motion.div>
          </div>
        </motion.div>

        {/* Karaoke Side */}
        <motion.div
          layout
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          onMouseEnter={() => setHovered("karaoke")}
          onMouseLeave={() => setHovered(null)}
          className={`group flex items-center justify-center cursor-pointer px-6 md:px-14 relative overflow-hidden`}
          style={{
            ...sideStyle("karaoke"),
            backgroundImage: `url(${
              isActive("karaoke") ? mskaraokeCover : mkaraokeBG
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* 🔮 Gradient Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: isActive("karaoke") ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-black/60 backdrop-blur-sm z-0"
          />

          <motion.div
            className="absolute inset-0 z-0"
            animate={{ scale: isActive("karaoke") ? 1.05 : 1 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            style={{
              backgroundImage: `url(${
                isActive("karaoke") ? mskaraokeCover : mkaraokeBG
              })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: isActive("karaoke") ? "blur(1px)" : "none",
            }}
          />

          <div className="flex flex-col items-start gap-4 md:gap-8 z-10 relative">
            <motion.div
              initial={{ x: "-50%", y: "-50%" }}
              animate={
                isActive("karaoke")
                  ? {
                      x: 0,
                      y: 0,
                      left: "0",
                      top: "0",
                      position: "relative",
                    }
                  : {
                      x: "0",
                      y: "0",
                      left: "6rem",
                      top: "5rem",
                      position: "relative",
                    }
              }
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="z-10"
            >
              <img
                src={assets.image.MkaraokeLogo}
                alt="MKaraoke"
                className="h-14 md:h-20 w-auto max-w-full"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{
                opacity: isActive("karaoke") ? 1 : 0,
                x: isActive("karaoke") ? 0 : 50,
              }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              className="flex flex-col items-start gap-4 md:gap-8"
            >
              <p className="text-white font-normal leading-6 text-sm md:text-base">
                MKaraoke танд бүтээлээрээ тогтмол орлого олох боломжийг олгож
                <br className="hidden md:block" /> байна. Та өөрийн статистик,
                хандалт, өсөлтийг эндээс хянаарай.
              </p>
              <motion.button
                whileHover={{ scale: 1.04 }}
                className="bg-mmusic px-6 py-3 text-white rounded-full flex items-center gap-2"
                onClick={() => {
                  const accessData = JSON.parse(
                    localStorage.getItem("Current-Access"),
                  );
                  if (accessData?.is_karaoke_active === false) {
                    setBEPopupMessage("unauthorizedKaraokeAccess");
                    setBEPopupType("Warning");
                    setBEPopup(true);
                  } else {
                    navigate("/karaoke");
                  }
                }}
              >
                <p>Үргэлжлэх</p>
                <IconController
                  src={assets.svg.rightArrow}
                  className="w-6 h-6"
                />
              </motion.button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </Wrapper>
  );
};

export default SplitScreen;
